import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared/base-path";
import { WorkspaceChangesApi } from "../../api/workspace-changes/service.ts";
import { makeWorkspaceChangesApi } from "../../api/workspace-changes/live.ts";
export const WorkspaceChangesBrowserPortsLive = Layer.effect(WorkspaceChangesApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeWorkspaceChangesApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
